<template>
  <div>
    <div class="head1">
      <div class="bg">
        <div class="w1200">
          <div
            class="logo"
            :style="'background-image:url(' + configure.logo2 + ')'"
          ></div>
          <div class="nav">
            <ul>
              <li :class="$route.path.split('/')[1] == 'printManagement' ? 'on' : ''">
                <router-link to="/printManagement">打印管理</router-link>
              </li>
              <li :class="$route.path.split('/')[1] == 'printStatistics' ? 'on' : ''">
                <router-link to="/printStatistics">打印统计</router-link>
              </li>
            </ul>
          </div>
          <div
            style="line-height: 70px; float: right; color: #fff; cursor: pointer"
            @click="out"
          >
            退出登录
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: { ...mapState(["configure"]) },
  methods: {
    out() {
      this.$confirm("是否退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax.post("/server/print/user/logout", {}).then((res) => {
            this.$router.push({ name: "loginPrinting" });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/print.vue